import React from 'react';
import cx from 'classnames';
import './Badge.scss';

interface BadgeProps {
  className?: string;
  color: 'primary' | 'base' | 'gray' | 'green';
  badgeContent: number;
}

const Badge = (props: BadgeProps): JSX.Element => {
  const { badgeContent, className, color = 'base' } = props;

  return <span className={cx('amondz-badge', className, color)}>{badgeContent}</span>;
};

export default Badge;
